import { render } from "./PlansPlanCard.vue?vue&type=template&id=79740be7&scoped=true&ts=true"
import script from "./PlansPlanCard.vue?vue&type=script&lang=ts"
export * from "./PlansPlanCard.vue?vue&type=script&lang=ts"

import "./PlansPlanCard.vue?vue&type=style&index=0&id=79740be7&lang=scss&scoped=true"

import exportComponent from "/home/iskra/Projects/verum/admin-panel/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79740be7"]])

export default __exports__